// removed by extract-text-webpack-plugin
module.exports = {"Button":"Button__Button__QI7b2","Success":"Button__Success__2dHUt","Danger":"Button__Danger__2xnhN","Neutral":"Button__Neutral__2cf24","Grey":"Button__Grey__1kmR9","NoMargin":"Button__NoMargin__17F94"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Button/Button.css
// module id = 279
// module chunks = 0